import { Route } from "react-router-dom";
import { SimpleErrorBoundary } from "~/components";
import { lazyNamedPage } from "~/utils/routing/lazyPage";
import {
  AddUnitPlanPageAction,
  AddUnitPlanPageLoader,
} from "./AddUnitPlanPage/loaders/AddUnitPlanPageLoader";
import {
  UnitPlanDetailsPageAction,
  UnitPlanDetailsPageLoader,
  unitPlanDetailsShouldRevalidate,
} from "./UnitPlanDetailsPage/loaders/UnitPlanDetailsPageLoader";
import {
  UnitPlanTablePageLoader,
  unitPlanTableShouldRevalidate,
} from "./UnitPlanTablePage/loaders/UnitPlanTablePageLoader";

const UnitPlanTablePage = lazyNamedPage("UnitPlanTablePage", () =>
  import(
    /* webpackChunkName: "unit-plan" */
    "./UnitPlanTablePage/UnitPlanTablePage"
  ),
);
const AddUnitPlanPage = lazyNamedPage("AddUnitPlanPage", () =>
  import(
    /* webpackChunkName: "unit-plan" */
    "./AddUnitPlanPage/AddUnitPlanPage"
  ),
);
const UnitPlanDetailsPage = lazyNamedPage("UnitPlanDetailsPage", () =>
  import(
    /* webpackChunkName: "unit-plan" */
    "./UnitPlanDetailsPage/UnitPlanDetailsPage"
  ),
);

export const UnitPlanPagesRoutes = () => (
  <>
    <Route
      path="/unit-plan"
      loader={UnitPlanTablePageLoader}
      shouldRevalidate={unitPlanTableShouldRevalidate}
      ErrorBoundary={() => SimpleErrorBoundary()}
      element={<UnitPlanTablePage />}
    />
    <Route
      path="/add-unit-plan"
      loader={AddUnitPlanPageLoader}
      action={AddUnitPlanPageAction}
      ErrorBoundary={() => SimpleErrorBoundary()}
      element={<AddUnitPlanPage />}
    />
    <Route
      path="/property/:propertyID/add-unit-plan"
      loader={AddUnitPlanPageLoader}
      action={AddUnitPlanPageAction}
      ErrorBoundary={() => SimpleErrorBoundary()}
      element={<AddUnitPlanPage />}
    />
    <Route
      path="/property/:propertyID/unit-plan/:unitPlanID"
      loader={UnitPlanDetailsPageLoader}
      action={UnitPlanDetailsPageAction}
      shouldRevalidate={unitPlanDetailsShouldRevalidate}
      ErrorBoundary={() => SimpleErrorBoundary()}
      element={<UnitPlanDetailsPage />}
    />
  </>
);
